import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// @ts-ignore
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const getRecaptchaVerifier = (containerId: string) => {
  if (typeof window === 'undefined') return null;

  // Clear any existing reCAPTCHA widgets
  const element = document.getElementById(containerId);
  if (element) {
    element.innerHTML = '';
  }

  // Create new verifier
  const verifier = new RecaptchaVerifier(
        auth,
        containerId,
        {
          size: 'invisible',
          callback: () => {
            console.log('reCAPTCHA verified');
          },
      'expired-callback': () => {
        console.log('reCAPTCHA expired');
        // Clear the container to force a new reCAPTCHA on next attempt
        const element = document.getElementById(containerId);
        if (element) {
          element.innerHTML = '';
  }
      }
    }
  );

  return verifier;
};

export default app;
